import { UAParser } from 'ua-parser-js';

export const isUnsupportedBrowser = () => {
  const unsupportedBrowserList = ['IE', 'IEMobile'];
  const parser = new UAParser();
  const browser = parser.getBrowser().name;
  return browser !== undefined && unsupportedBrowserList.indexOf(browser) > -1;
};